var React = require('react');

function MenuBurger (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"PDP-Mobile-Copy","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","transform":"translate(-11 -16)"},React.createElement("g",{"id":"TopBar","fill":"currentColor"},React.createElement("g",{"id":"Burger","transform":"translate(11 16)"},[React.createElement("path",{"id":"Rectangle","d":"M0 0h23v2H0z","key":0}),React.createElement("path",{"id":"Rectangle-Copy","d":"M0 8h23v2H0z","key":1}),React.createElement("path",{"id":"Rectangle-Copy-2","d":"M0 16h23v2H0z","key":2})]))));
}

MenuBurger.defaultProps = {"width":"23","height":"18","viewBox":"0 0 23 18"};

module.exports = MenuBurger;

MenuBurger.default = MenuBurger;
